import { Alert, AlertTitle, Button, Dialog, DialogActions } from "@mui/material";

const DeleteConfimrationModal = (props) => {
    const { entity, onConfirm, onCancel, confirmationMessage } = props;

    return <Dialog open={!!entity}>
        <Alert severity="warning">
            <AlertTitle>Are you sure?</AlertTitle>
            {confirmationMessage || `Are you sure? This cannot be reverted!`}
        </Alert>
        <DialogActions>
            <Button variant='contained' onClick={onCancel}>Cancel</Button>
            <Button variant='contained' onClick={() => onConfirm(entity.id)}>Delete</Button>
        </DialogActions>
    </Dialog>
}

export default DeleteConfimrationModal;